<p>auth-modal works!</p>
